export default __webpack_public_path__ + "static/media/header-logo.5878a3cb.png";